import { defineMessages } from '@cookbook/solid-intl'

export const messages = defineMessages({
    acceptButton: {
        defaultMessage: 'Accept',
        id: 'CookieBanner.acceptButton',
    },
    body: {
        defaultMessage: 'We use cookies to store your preferences, improve product performance, and analyze traffic. For more details, refer to our <privacyLink>Privacy Policy</privacyLink>.',
        id: 'CookieBanner.body',
    },
    declineButton: {
        defaultMessage: 'Decline',
        id: 'CookieBanner.declineButton',
    },
    title: {
        defaultMessage: 'We value your privacy',
        id: 'CookieBanner.title',
    },
})
